import firebase from '../components/firebase';
import { MessageForDatabase } from '../components/views/Chat/types';

export const messagesRef = () => firebase.database().ref('chat_messages');
export const messageRef = (messageId: string) => messagesRef().child(messageId);

export const createMessage = async ({
  content,
  uid,
  username,
}: {
  content: string;
  uid: string;
  username: string;
}) => {
  if (!firebase.auth().currentUser) {
    throw new Error('Must be authenticated to send messages');
  }

  if (!content?.trim()) {
    throw new Error('Message content cannot be empty');
  }

  const message: MessageForDatabase = {
    content: content.trim(),
    userId: uid,
    username,
    timestamp: firebase.database.ServerValue.TIMESTAMP,
  };

  try {
    const newRef = messagesRef().push();
    await newRef.set(message);
    return newRef.key;
  } catch (error) {
    console.error('Error creating message:', error);
    throw new Error('Failed to send message. Please try again.');
  }
};

export const editMessage = async ({
  messageId,
  content,
  uid,
}: {
  messageId: string;
  content: string;
  uid: string;
}) => {
  const snapshot = await messageRef(messageId).once('value');
  const message = snapshot.val();

  if (!message || message.userId !== uid) {
    throw new Error('Cannot edit this message');
  }

  return messageRef(messageId).update({
    content: content.trim(),
    edited: true,
    editedAt: firebase.database.ServerValue.TIMESTAMP,
  });
};

export const deleteMessage = async ({
  messageId,
  uid,
}: {
  messageId: string;
  uid: string;
}) => {
  const snapshot = await messageRef(messageId).once('value');
  const message = snapshot.val();

  if (!message || message.userId !== uid) {
    throw new Error('Cannot delete this message');
  }

  return messageRef(messageId).remove();
};
